import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../utils/utilNumber";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { TextLoca } from "../generic/text/TextLoca";
import { TimeRemaining } from "../time/TimeRemaining";
export var DiscountEventTimer = function (_a) {
    var discountAmount = _a.discountAmount, endTime = _a.endTime, _b = _a.idLoca, idLoca = _b === void 0 ? IdLoca.value_percentage : _b;
    var percentageLocaReplacement = new Map([
        [ReplacementLoca.zero_0, utilNumber.format(discountAmount)],
    ]);
    return (React.createElement("div", { className: "flex flex--stacked flex--guts" },
        React.createElement(Icon, { icon: IdIcon.BadgePremiumIcn, styleId: IdStyles.IconExtraLarge },
            React.createElement("div", { className: "flex flex--stacked flex--guts h100 pb__medium" },
                React.createElement(TextLoca, { id: idLoca, className: IdStyles.TextButtonDefault, replacements: percentageLocaReplacement }))),
        React.createElement(TimeRemaining, { backgroundClassName: IdStyles.ExpansionTimer, backgroundSize: "small", remainingTime: endTime, fontClassName: IdStyles.TextBoldPrimary, className: "icon-with-text discount-event-badge-timer" })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/discount-event/DiscountEventTimer.tsx
// module id = 440
// module chunks = 3